import { ASIDE, wrapText } from "shared/react";
import { USER } from "../util/user.js";

/** Only render children if the current logged in user is the specified profile. */
export function ProfileOwnerCondition({ uid, children, fallback = null }: { uid: string; children: React.ReactNode; fallback?: React.ReactNode }): React.ReactElement | null {
	return uid === USER.data.uid ? <>{children}</> : wrapText(fallback, ASIDE);
}
